import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EmptyState from './common/EmptyState';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      padding={3}
    >
      <EmptyState
        title="Page Not Found"
        description="The page you're looking for doesn't exist or has been moved."
      />

      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/')}
        sx={{ mt: 4 }}
      >
        Go to Home
      </Button>
    </Box>
  );
};

export default NotFoundPage;
